import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/logo@2x.png'


const _withScopeId = n => (_pushScopeId("data-v-10a43cdc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "nav"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  height: "50",
  alt: ""
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Logout", -1))
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_text = _resolveComponent("n-text")!
  const _component_n_space = _resolveComponent("n-space")!

  return (!_ctx.isFromAgency)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createVNode(_component_n_space, {
          class: "wrap",
          justify: "space-between",
          align: "center",
          style: {"max-width":"1200px","margin":"auto","height":"100%"}
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: "logo",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goIndex()))
            }, _hoisted_3),
            (_ctx.user.name)
              ? (_openBlock(), _createBlock(_component_n_space, {
                  key: 0,
                  class: "avatar",
                  align: "center",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isShowLogout = !_ctx.isShowLogout))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      src: _ctx.user.avatar_url,
                      alt: ""
                    }, null, 8, _hoisted_4),
                    _createVNode(_component_n_text, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.user.name), 1)
                      ]),
                      _: 1
                    }),
                    _withDirectives(_createElementVNode("div", {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.logout())),
                      class: "logout_tip"
                    }, _hoisted_6, 512), [
                      [_vShow, _ctx.isShowLogout]
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}